<template>
  <div class="frame11_body">
    <div class="frame11">
      <div class="frame11_top">
        盈利能力-回报率
        <img
          src="../../../../public/img/shares_Info/close.png"
          alt=""
          @click="frame11_close"
        />
      </div>
      <div class="frame11_content">
        <div class="frame11_content_title">净资产收益率ROE（加权）</div>
        <div class="frame11_content_text">
          【释义】：净资产收益率是公司净利润和净资产的比率，该指标反映股东权益的收益水平，用以衡量公司运用自有资本的效率。 指标值越高，说明投资带来的收益越高。一般国内业绩优的公司ROE维持在15%以上，但是在实际应用过程中还需要结合行业，负债等具体分析。 
        </div>
        <div class="frame11_content_text">【算法】：归属母公司股东净利润/加权平均归属母公司股东的权益*100%</div>
        <div class="frame11_content_text">【单位】：%</div>
      </div>
      <div class="frame11_content">
        <div class="frame11_content_title">总资产净利率ROA</div>
        <div class="frame11_content_text">
          【释义】：总资产净利率是企业报告期内获得的可供投资者分配的经营收益占总资产的百分比，反映投资者（含少数股东权益）利用全部资产获利的能力。指标值越高，资产利用效果越好，增加收入和节约成本的效果就越好。本指标的“资产”是合并报表的总资产（即包含归属少数股东的权益），因此，“净利润”采用全部净利润（即包含少数股东损益）。该指标剔除了母公司控股比例对投资收益的影响，可用于同行业不同公司的收益水平比较。 
        </div>
        <div class="frame11_content_text">
          【算法】：总资产净利率ROA=净利润（含少数股东损益）*2/（期初总资产+期末总资产）*100% 
        </div>
        <div class="frame11_content_text">【单位】：%</div>
      </div>
      <div class="frame11_content">
        <div class="frame11_content_title">投入资本回报率ROIC</div>
        <div class="frame11_content_text">
          【释义】：ROIC是生产经营活动中所有投入资本赚取的收益率，而不论这些投入资本是被称为债务还是权益。分子是指公司如果完全按权益筹资所应报告的税后利润，分母是指公司所要求回报的现金来源的总和。 
        </div>
        <div class="frame11_content_text">
          【算法】：投入资本回报率ROIC=净利润*2/（期初投入资本+期末投入资本）*100 全部投入资本=归属母公司股东权益（不含少数股东权益）+总负债-无息流动负债-无息长期负债 
        </div>
        <div class="frame11_content_text">【单位】：%</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    frame11_close() {
      this.$emit("frame11_close");
    },
  },
};
</script>

<style scoped>
.frame11_body {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  top: 0;
  overflow-y: scroll;
  z-index: 9999999;
}
.frame11 {
  width: 448px;
  height: 1040px;
  background-color: #ffffff;
  box-shadow: 0px 2px 51px 6px rgba(0, 0, 0, 0.08);
  border-radius: 6px;
  padding: 30px 36px;
  margin: 50px auto;
  margin-top: 200px;
}
.frame11_top {
  width: 100%;
  height: 50px;
  border-bottom: 1px solid #f4f4f4;
  text-align: center;
  font-size: 20px;
  font-weight: bold;
}
.frame11_content {
  margin-top: 28px;
}
.frame11_top img {
  width: 19px;
  float: right;
  margin-top: 3px;
}
.frame11_content_title {
  font-size: 16px;
  font-weight: bold;
  color: #333333;
  line-height: 30px;
}
.frame11_content_text {
  font-size: 16px;
  font-weight: bold;
  color: #666666;
  line-height: 30px;
}
</style>